import { AppSettings } from 'src/app/core/configs/app.settings';
import { PageState } from 'src/app/core/base-page';
import { Entity } from 'src/app/core/data/schema/entity';
import { Upload } from 'src/app/core/data/schema/upload';
import { ServiceHelper } from 'src/app/core/helper/services.helper';

export class SalesPerson extends Entity {

    static className = 'SalesPerson';
    static idField = 'salesPersonId';
    static controller = 'salespeople';

    salesPersonId: number;
    raffleId: number;
    name: string;
    email: string;
    code: string;
    syncing: boolean;
    totalSales: number;
    salesTeamId: number;
    teamName: string;
    trackingLink: string;
    salesLinkGuid: string;
    activityLink: string;
    welcomeEmailSent: boolean;
    dateDeactivated: string | null;
    isActive: boolean; // calculated field used by table and filters


    public constructor(init?: Partial<SalesPerson>) {
        super(SalesPerson.className, SalesPerson.idField, SalesPerson.controller);
        Object.assign(this, init);
        this.syncing = false;
        this.isActive = this.dateDeactivated == null || this.dateDeactivated === '';
    }

    static async fetchSalesPeopleByRaffle(raffleId: number) {
        return await super.fetchArray(SalesPerson, null, `raffle/${raffleId}`);
    }

    static async fetchSellersCSV(raffleId: number) {
        return await super.fetchUntyped('Sales CSV', 'raffles', `${raffleId}/export/sales-people`, 'text');
    }

    static async sendWelcomeEmails(raffleId: number) {
        return await super.factory.httpService.post(null, `salespeople/sendWelcomeEmails/${raffleId}`);
    }

    static async importSalesPeople(file: Upload, raffleId: number) {
        const csvResults = await super.factory.httpService.upload(
            await file.toFormData(file.filename),
            `salespeople/import/${raffleId}`,
            'json'
        );
        return new CSVProcessResults(csvResults);
    }

    static async deleteMany(pageState: PageState, raffleId: number, items: number[]) {
        if (items.length === 0) {
            return false;
        }

        const doDelete = await ServiceHelper.confirmSomething(
            'Delete Sellers',
            'Delete the selected sellers? If any sales are linked to these sellers, they will be re-attributed to the organization.',
            'Cancel',
            'Confirm'
        );

        if (!doDelete) {
            return;
        }

        const loader = await ServiceHelper.displayLoad('Deleting sellers...');
        try {
            pageState.busy = true;
            await super.factory.httpService.post(items, `salespeople/deleteMany/${raffleId}`);
            ServiceHelper.displayToast('The sellers were deleted!');
            return true;
        } catch (error) {
            ServiceHelper.displayAlert('Error Deleting Sellers', error);
            return false;
        } finally {
            pageState.busy = false;
            loader.dismiss();
        }
    }
}

export class CSVProcessResults {
    salesPeople: SalesPerson[] = [];
    duplicateRows: number[] = [];
    duplicateSellers: number[] = [];
    invalidRows: CSVLineError[] = [];
    teamsAdded = 0;

    constructor(init?: Partial<CSVProcessResults>) {
        Object.assign(this, init);
    }
}

export class CSVLineError {
    lineNumber: number;
    errorMessage: string;
    lineContent: string;

    constructor(init?: Partial<CSVLineError>) {
        Object.assign(this, init);
    }
}
